export class LoginHelpModalService {
  private isShow: boolean;

  constructor() {
    this.isShow = false;
  }

  get shouldShow(): boolean {
    return this.isShow;
  }

  show(): void {
    this.isShow = true;
  }

  hide(): void {
    this.isShow = false;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/services/login_help_modal_service.ts